import Button from '../../Components/Buttons';
import NewsCard from '../../Components/NewsCard';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';
import { useEffect, useContext }from 'react';
import { BlogContext } from '../../Context/Blog/context';
import { fetchBlogsAction } from '../../Context/Blog/action';
import { DiseaseContext } from '../../Context/Disease';
import { dropRightWhile, drop } from 'lodash';
import routes from '../../utils/routes';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import TileItem from '../../Components/TileItem/ArticleTile';
import styles from './new.module.css';

const HomeNewsSection = () => {
  const isTablet = useMediaQuery({ query: "(max-width: 768px)" });
  const { push } = useHistory();

  const { blogState, dispatch } = useContext(BlogContext);
  const {
    diseaseState: {
      activeDisease: { disease_id },
    },
  } = useContext(DiseaseContext);

  useEffect(() => {
    dispatch(
      fetchBlogsAction({
        disease: disease_id,
        page: 1,
      })
    );
  }, [dispatch, disease_id]);


  const handleRouting = () => push(routes?.news);
  return (
    <>
      {!!blogState?.blogs?.data?.length && (
        <div className="bg-moon py-6 md:py-72 lg:py-104">
          <div className="layout__wrapper">
            <header className="flex items-center">
              <h6 className="font-bold leading-48 text-caramBar text-28px md:text-38 md:mb-3">
                Updates
              </h6>
              <div className="flex-grow"></div>
              <div className="w-auto flex-shrink-0">
                <Button onClick={handleRouting} type="button" outline>
                  <span className="inline-block p-2">
                    <span>Read More</span>
                  </span>
                </Button>
              </div>
            </header>
            <div className="pt-6 lg:flex  ">
              <div className="lg:w-3/5 lg:mr-9">
                {!!blogState?.blogs?.data?.length &&
                  dropRightWhile(
                    [...blogState?.blogs?.data],
                    (_, index) => index > 1
                  ).map((blog) => (
                    <div className="mb-5 last:mb-0 md:h-250 lg:h-216 overflow-hidden">
                      <Link to={`${routes.news}/${blog?.slug}`}>
                        <NewsCard
                          thumbNailClass="w-full md:w-1/2  md:h-full "
                          blog={blog}
                          variant={!isTablet ? "landscape" : ""}
                        />
                      </Link>
                    </div>
                  ))}
              </div>

              <div className="hidden lg:block lg:w-2/5">
                {!!drop([...blogState?.blogs?.data], 2)[0]?.id && (
                  <Link
                    to={`${routes.news}/${
                      drop([...blogState?.blogs?.data], 2)[0]?.slug
                    }`}
                  >
                    <NewsCard
                      shadowless
                      blog={drop([...blogState?.blogs?.data], 2)[0]}
                    />
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeNewsSection;
